import { render, staticRenderFns } from "./DXF.vue?vue&type=template&id=c5f3a806"
import script from "./DXF.vue?vue&type=script&lang=js"
export * from "./DXF.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports